import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-gender-uc',
    templateUrl: './bar-chart-stable-unstable-gender-uc.component.html',
    styleUrls: ['./bar-chart-stable-unstable-gender-uc.component.css']
})

export class BarChartStableUnstableGenderUCComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  recidiva = [];
  // other arrays
  stabiliRecidivaUomo = 0;
  stabiliRemissioneUomo = 0;
  instabiliMiglRecidivaUomo = 0;
  instabiliPegRecidivaUomo = 0;
  instabiliMiglRemissioneUomo = 0;
  instabiliPegRemissioneUomo = 0;
  stabiliRecidivaDonna = 0;
  stabiliRemissioneDonna = 0;
  instabiliMiglRecidivaDonna = 0;
  instabiliPegRecidivaDonna = 0;
  instabiliMiglRemissioneDonna = 0;
  instabiliPegRemissioneDonna = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableUCGender: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['UOMO-STABILI','UOMO-IN MIGLIORAMENTO','UOMO-IN PEGGIORAMENTO',
  'DONNA-STABILI','DONNA-IN MIGLIORAMENTO','DONNA-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.recidiva,
      barThickness: 20,
      backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
      hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
      label: 'RECIDIVA',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
      data: this.remissione,
      barThickness: 20,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveGenderStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveGenderStableAndUnstable(){
    this.subscription = this.doctorService.getUCStableAndUnstableGender().subscribe( data => {
      let keys = Object.keys(data);
      //console.log("Keys: " + keys);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissioneUomo'){
          this.stabiliRemissioneUomo = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaDonna'){
          this.instabiliMiglRecidivaDonna = values[i];
        }
        else if (key === 'StabiliRemissioneDonna'){
          this.stabiliRemissioneDonna = values[i];
        }
        else if (key === 'InstabiliPegRecidivaDonna'){
          this.instabiliPegRecidivaDonna = values[i];
        }
        else if (key === 'InstabiliPegRemissioneDonna'){
          this.instabiliPegRemissioneDonna = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneDonna'){
          this.instabiliMiglRemissioneDonna = values[i];
        }
        else if (key === 'InstabiliPegRemissioneUomo'){
          this.instabiliPegRemissioneUomo = values[i];
        }
        else if (key === 'InstabiliPegRecidivaUomo'){
          this.instabiliPegRecidivaUomo = values[i];
        }
        else if (key === 'StabiliRecidivaUomo'){
          this.stabiliRecidivaUomo = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneUomo'){
          this.instabiliMiglRemissioneUomo = values[i];
        }
        else if (key === 'StabiliRecidivaDonna'){
          this.stabiliRecidivaDonna = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaUomo'){
          this.instabiliMiglRecidivaUomo = values[i];
        }
      }
      
      // riempio il vettore della categoria 'recidiva' in ordine stabili, miglioramento e peggioramento
      this.recidiva.push(this.stabiliRecidivaUomo);
      this.recidiva.push(this.instabiliMiglRecidivaUomo);
      this.recidiva.push(this.instabiliPegRecidivaUomo);
      this.recidiva.push(this.stabiliRecidivaDonna);
      this.recidiva.push(this.instabiliMiglRecidivaDonna);
      this.recidiva.push(this.instabiliPegRecidivaDonna);
      console.log("Recidiva: " + this.recidiva);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissioneUomo);
      this.remissione.push(this.instabiliMiglRemissioneUomo);
      this.remissione.push(this.instabiliPegRemissioneUomo);
      this.remissione.push(this.stabiliRemissioneDonna);
      this.remissione.push(this.instabiliMiglRemissioneDonna);
      this.remissione.push(this.instabiliPegRemissioneDonna);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableUCGender') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableUCGender = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableUCGender.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableUCGender.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA' ||
              this.myChartStableUnstableUCGender.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'RECIDIVA' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}